import React from 'react';
import Footer from '../Footer';
import styled from 'styled-components';
import GlobalStyles from '../../../styles/GlobalStyles';

const Layout = ({ children, onQuoteRequest }) => {
  return (
    <>
      <GlobalStyles />
      <Main>{children}</Main>
      <Footer />
    </>
  );
};

const Main = styled.main`
  min-height: 100vh;
  /* Navbar publishes its measured height as --navbar-height; the fallback only
     applies for the first paint. */
  padding-top: var(--navbar-height, 107px);
`;

export default Layout;
